<div class="page mantenedor-page">
  <div class="restricted-width">
    <div class="page-title"><b>Llámanos |</b> Mantenedor</div>
    <hr class="page-title-hr" />
    <div class="filters-container">
      <div class="filter-container">
        <input
          type="text"
          class="search-input"
          placeholder="Buscar..."
          [(ngModel)]="searchText"
        />
      </div>
      <div class="filters-container-right">
        <button (click)="recargarCampos()">Recargar Campos</button>
      </div>
    </div>
    <hr class="hr-mantenedor" />
    <div class="table-container">
      <table
        class="hr-separated-table table-with-row-separator table-with-row-separator-thick mantenedor-table"
        aria-label="Listado de solicitudes de Llamanos"
      >
        <caption>
          Tabla mantenedor
        </caption>
        <thead>
          <tr>
            <th scope="col">
              <div class="th-data width-390">
                <div class="th-text align-left">Categoría / Subcategoría</div>
              </div>
            </th>
            <th scope="col">
              <div class="th-data width-320">
                <div class="th-text align-left">Campos Obligatorios</div>
              </div>
            </th>
            <th scope="col">
              <div class="th-data width-320">
                <div class="th-text align-left">Campos No Obligatorios</div>
              </div>
            </th>
            <th scope="col">
              <div class="th-data width-120">
                <div class="th-text">Acción</div>
              </div>
            </th>
            <th scope="col">
              <div class="th-data width-120">
                <div class="th-text">Habilitar</div>
              </div>
            </th>
          </tr>
          <tr class="separator-row">
            <th scope="col" colspan="100%"></th>
          </tr>
        </thead>
        <tr class="table-separator-row-border-top"></tr>
        <tbody class="scrollable-body">
          @for (categoria of filteredCategorias; track categoria.key) {
            <tr>
              <td colspan="4" class="width-1173">
                <div
                  class="row-arrow"
                  [class.row-arrow--open]="openedCategoria.key == categoria.key"
                  (click)="toggleRowArrow(categoria)"
                >
                  {{ categoria.key }}
                </div>
              </td>
              <td class="width-120">
                <div class="switch">
                  <div
                    class="enabler-switch-container"
                    [ngClass]="{ 'disabled-switch': !categoria.active }"
                    (click)="toggleCategoriaSwitch(categoria)"
                  >
                    <div class="switch-button"></div>
                  </div>
                </div>
              </td>
            </tr>
            @if (openedCategoria.key == categoria.key) {
              @for (subcat of openedCategoria.subcategorias; track subcat.key) {
                <tr class="opened-row">
                  <td class="width-390">{{ subcat.key }}</td>
                  <td class="width-300">
                    <div class="ellipsis-cell width-300" ellipsisTooltip>
                      {{ subcat?.compulsory_fields?.join(", ") || "" }}
                    </div>
                  </td>
                  <td class="width-300">
                    <div class="ellipsis-cell width-300" ellipsisTooltip>
                      {{ subcat?.optional_fields?.join(", ") || "" }}
                    </div>
                  </td>
                  <td class="center">
                    <img
                      src="assets/edit.svg"
                      alt="editar"
                      (click)="openEditDialog(subcat)"
                      class="edit-icon"
                    />
                  </td>
                  <td class="width-120">
                    <div class="switch">
                      <div
                        class="enabler-switch-container"
                        [ngClass]="{ 'disabled-switch': !subcat.active }"
                        (click)="toggleSubcategoriaSwitch(subcat)"
                      >
                        <div class="switch-button"></div>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>
  </div>
  <lib-custom-alert
    [isVisible]="showAlert"
    [closeFunc]="closeAlert"
    [acceptFunc]="closeAlert"
    [hideGreyBackground]="hideGreyBackground"
    [showGreyBackground]="showGreyBackground"
    [scrollTo]="scrollTo"
    [icon]="alertIcon"
    [title]="alertTitle"
    [content]="alertContent"
  >
  </lib-custom-alert>
</div>
